import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

// Patients
export const getPatients = () => api.get("/patients");
export const searchPatients = (q) => api.get(`/patients/search?q=${encodeURIComponent(q)}`);
export const getPatient = (id) => api.get(`/patients/${id}`);
export const createPatient = (data) => api.post("/patients", data);
export const deletePatient = (id) => api.delete(`/patients/${id}`);

// Clinical records
export const addDiagnosis = (pid, data) => api.post(`/patients/${pid}/diagnoses`, data);
export const deleteDiagnosis = (pid, rid) => api.delete(`/patients/${pid}/diagnoses/${rid}`);

export const addMedication = (pid, data) => api.post(`/patients/${pid}/medications`, data);
export const deleteMedication = (pid, rid) => api.delete(`/patients/${pid}/medications/${rid}`);

export const addRiskAlert = (pid, data) => api.post(`/patients/${pid}/risk-alerts`, data);
export const deleteRiskAlert = (pid, rid) => api.delete(`/patients/${pid}/risk-alerts/${rid}`);

export const addFollowUp = (pid, data) => api.post(`/patients/${pid}/follow-ups`, data);
export const deleteFollowUp = (pid, rid) => api.delete(`/patients/${pid}/follow-ups/${rid}`);

export const addNote = (pid, data) => api.post(`/patients/${pid}/notes`, data);
export const deleteNote = (pid, rid) => api.delete(`/patients/${pid}/notes/${rid}`);

// Summary
export const generateSummary = (pid) => api.post(`/patients/${pid}/generate-summary`);
export const getSummary = (pid) => api.get(`/patients/${pid}/summary`);

export default api;
